import Tooltip from "@material-ui/core/Tooltip";
import Button, { ButtonTypeMap } from "@material-ui/core/Button";
import {Dialog, Theme} from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import React, {useState} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import VisibilityIcon from '@material-ui/icons/Visibility';
import Notepad from './Notepad/Notepad'
import "./Notepad/styles.css";
import IconButton from "@material-ui/core/IconButton";




const useStyles = makeStyles((theme: Theme) => ({

  graphViewContainer: {
    width: "72vw",
    height: '72vh'
  },
  btnRoot: {
    textTransform: 'none',
    backgroundColor: 'white'
  },
  hfeIconStyles: {
    backgroundColor: 'none'
  }

}));


type TreeReferenceButtonProps = {
  title: string,
  tooltipTitle: string,
  disabled?: boolean,
  graphView: any,
  buttonVariant?: ButtonTypeMap['props']['variant'],
  icon?: any,
  isMainHFEPage: boolean
}

const NotePadButton = (props: TreeReferenceButtonProps) => {

  const {cfId, tooltipTitle, title, graphView, disabled, buttonVariant, icon, isMainHFEPage } = props;
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  return (
    <React.Fragment>
      <Tooltip title={tooltipTitle}>

        {
          icon ?        <IconButton onClick={(e) => {
            e.stopPropagation();
            setOpen(true);
        }}>
                        {icon}
                        </IconButton>
                        :        <Button
          className={icon ? classes.btnRoot : classes.btnRoot}
          startIcon={icon ? icon : <VisibilityIcon />}
          variant={"contained"}
          
          disabled={disabled}
          onClick={(e) => {
              e.stopPropagation();
              setOpen(true);
          }}
        >
          {title}
        </Button>
        }

      </Tooltip>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth={false}
        fullWidth
        onClick={(e) => {
            e.stopPropagation();
        }}
        PaperProps={{
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            border: 'none',
            alignContent: 'center'
          },
        }}
      >
        <DialogContent >
         <Notepad 
         cfId={cfId}
         className='App'
         setOpen={setOpen}/>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
};

export default NotePadButton;
